/** UUID de la skill de TiendaNube en el marketplace (índice `skills` del backend). */
export const TIENDANUBE_SKILL_ID = '7d2f4c8a-91b3-4e6d-a5f0-3c8e2b7d9a14';

/**
 * Clave de sessionStorage donde el botón de conexión deja el `state` del OAuth para
 * que el callback lo compare. Compartida para que ambos lados no se desincronicen.
 */
export const TIENDANUBE_STATE_STORAGE_KEY = 'tiendanube_oauth_state';
